module.exports = __webpack_public_path__ + "static/media/login-logo.e93a15e5.svg";